import { useContext } from "react";
import { organizationSwitchContext } from "../context/OrganizationSwitchContext";

export const useOrganizationSwitchContext = () => {
  const context = useContext(organizationSwitchContext);

  if (!context) {
    throw new Error(
      "Hook useOrganizationSwitchContext is used outside of its Provider."
    );
  }

  return context;
};
